import React, { useState, useEffect, useRef } from 'react'
import { Colors } from '@auteco/theme'
import MaterialTable from '@material-table/core'
import { Card, IconButton, Typography } from '@material-ui/core'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import VisibilityIcon from '@material-ui/icons/Visibility'
import HelpIcon from '@material-ui/icons/Help'
import { updateMaterialStatus } from '@auteco/services/snopServices'
import { initialAlert, statesSnop } from '@auteco/constants'
import { Alert } from '../Alert'
import useStyles from './styles'

const MaterialsTableShared = ({
  title,
  materials,
  handleViewDetails,
  getUpdatedMaterials,
  loading,
  getModelsApplicationMaterialsByFiltersSaved, 
  setMaterials,
  setMaterialsFiltered,
  setRefreshModels,
}) => {
  const [alertInfo, setAlertInfo] = useState(initialAlert)
  const classes = useStyles()
  const tableRef = useRef()
  const LOCAL_STORAGE_KEY = `materialsTableSharedColumns_${title.replace(/\s+/g, '_')}`

  const updateMaterial = async ({ material, status }) => {
    const body = {
      material,
      estado: status,
    }
    const { success } = await updateMaterialStatus({ params: body })
    if (success === 1) {
      setRefreshModels(false)
      setAlertInfo(initialAlert)
      // await getUpdatedMaterials()
      // getModelsApplicationMaterialsByFiltersSaved()
      const updatedMaterials = materials.map((item) =>
        item.id === material ? { ...item, fc: status, fg: status } : item,
      )
      setMaterials(updatedMaterials)
      setMaterialsFiltered(updatedMaterials)
      console.log("ok")
    }
  }

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }

  const onReturnMaterial = ({ material }) => {
    setAlertInfo({
      title: '¡Espera!',
      content: 'Estás a punto de retornar un material.',
      textBtn1: 'Cancelar',
      textBtn2: 'Continuar',
      open: true,
      onClose: onCloseAlert,
      funcBtn: () => updateMaterial({ material, status: statesSnop.retornado }),
    })
  }

  const onPassMaterial = ({ material }) => {
    setAlertInfo({
      title: '¡Espera!',
      content: 'Estás a punto de pasar un material.',
      textBtn1: 'Cancelar',
      textBtn2: 'Continuar',
      open: true,
      onClose: onCloseAlert,
      funcBtn: () => updateMaterial({ material, status: statesSnop.dudas }),
    })
  }

  function inverseLogisticP(y) {
    y /= 100
    if (y < 0 || y > 1) {
      throw new Error('El valor de y debe estar en el rango (0, 1)')
    }
    const result = -Math.log((1 - y) / (y + 1))
    return result * 100
  }

  // Definir las columnas base
  const getBaseColumns = () => [
    {
      title: 'Material',
      field: 'id',
    },
    {
      title: `MAPE (${materials.length > 0 ? inverseLogisticP(materials[0]?.porc_mape_norm_eq).toFixed(2) : 0}%)`,
      field: 'porc_mape',
      render: (rowData) => <p style={{"color":(materials.length > 0 && inverseLogisticP(materials[0]?.porc_mape_norm_eq).toFixed(2)) < (Math.abs(rowData.porc_mape * 100)) ? "red": "black"}}>{((rowData.porc_mape) * 100).toFixed(2)}%</p>,
      sorting: false,
      hidden: false,
    },
    {
      title: `BIAS (${materials.length > 0 ? inverseLogisticP(materials[0]?.porc_bias_norm_eq).toFixed(2) : 0}%)`,
      field: 'porc_bias',
      render: (rowData) => <p style={{"color":(materials.length > 0 && inverseLogisticP(materials[0]?.porc_bias_norm_eq).toFixed(2)) < (Math.abs(rowData.porc_bias * 100)) ? "red": "black"}}>{((rowData.porc_bias) * 100).toFixed(2)}%</p>,
      sorting: false,
      hidden: false,
    },
    {
      title: `Var Costo (${materials.length > 0 ? inverseLogisticP(materials[0]?.porc_cambio_costo_norm_eq).toFixed(2) : 0}%)`,
      field: 'por_cambio_costo',
      render: (rowData) => <p style={{"color":(materials.length > 0 && inverseLogisticP(materials[0]?.porc_cambio_costo_norm_eq).toFixed(2)) < (Math.abs(rowData.por_cambio_costo * 100)) ? "red": "black"}}>{((rowData.por_cambio_costo) * 100).toFixed(2)}%</p>,
      sorting: false,
      hidden: false,
    },
    {
      title: `Agotados (${materials.length > 0 ? inverseLogisticP(materials[0]?.porc_disponibilidad_norm_eq).toFixed(2) : 0}%)`,
      field: 'porc_disponibilidad',
      render: (rowData) => <p style={{"color":(materials.length > 0 && inverseLogisticP(materials[0]?.porc_disponibilidad_norm_eq).toFixed(2)) < (Math.abs(rowData.porc_disponibilidad * 100)) ? "red": "black"}}>{((rowData.porc_disponibilidad) * 100).toFixed(2)}%</p>,
      sorting: false,
      hidden: false,
    },
    {
      title: 'Descripción',
      field: 'texto',
    },
    {
      title: 'Lead Time',
      field: 'leadtime',
    },
    {
      title: 'L3M',
      field: 'demanda',
    },
    {
      title: 'Bias',
      field: 'bias',
    },
    {
      title: 'Baseline',
      field: 'baseline',
    },
    {
      title: 'Category',
      field: 'category',
    },
    {
      title: 'Delta',
      field: 'gerente',
    },
    {
      title: 'Evento',
      field: 'eventos',
    },
    {
      title: 'Presupuesto',
      field: 'presupuesto',
    },
    {
      title: 'Categoría',
      field: 'categoria',
      sorting: false,
    },
    {
      title: 'Marca',
      field: 'marca',
      sorting: false,
    },
    {
      title: 'Familia',
      field: 'familia',
      sorting: false,
    },
    {
      title: 'Clasificación',
      field: 'clasificacion',
      sorting: false,
    },
    {
      title: 'Comprable',
      field: 'estado',
      render: (rowData) => (rowData.estado ? 'Si' : 'No'),
      sorting: false,
    },
    {
      title: 'Acciones',
      field: 'acciones',
      render: (rowData) => (
        <div className={classes.actionBtnsContainer}>
          {true !== 1 ? ( // TO DO
            <>
              {(rowData.fc !== 0 && rowData.fg !== 2 && rowData.fg !== 1) && (
                <IconButton
                  className={classes.actionBtn}
                  onClick={() => onReturnMaterial({ material: rowData.id })}
                >
                  <SettingsBackupRestoreIcon />
                </IconButton>
              )}

              <IconButton 
                className={classes.actionBtn}
                onClick={() => handleViewDetails({ material: rowData.id })}
              >
                <VisibilityIcon />
              </IconButton>
              {rowData.fg !== 2 && rowData.fg !== 1 && (
                <IconButton
                  className={classes.actionBtn}
                  onClick={() => onPassMaterial({ material: rowData.id })}
                >
                  <HelpIcon />
                </IconButton>
              )}
            </>
          ) : (
            <Typography>Finalizado</Typography>
          )}
        </div>
      ),
    },
    {
      title: 'Estado     ',
      field: 'fc',
      render: (rowData) => (
        <div className={classes.actionBtnsContainer}>
          {rowData.fc === 3 ? (
            <>
              ↩︎ <Typography>Retornado</Typography>
            </>
          ) : rowData.fg === 2 ? (
            <>
              {' '}
              <Typography>❓🟢 Finalizado</Typography>
            </>
          ) : rowData.fg === 1 ? (
            <Typography>🟢 Finalizado</Typography>
          ) : rowData.fc === 2 ? (
            <>
              {' '}
              <Typography>❓🟡 Por revisar</Typography>
            </>
          ) : rowData.fc === 1 ? (
            <Typography> 🟡 Por revisar</Typography>
          ) : rowData.fc === 0 ? (
            <Typography> ⚪ Pendiente</Typography>
          ) : (
            <></>
          )}
        </div>
      ),
      sorting: false,
    },
  ]

  // Estado para las columnas configuradas
  const [columns, setColumns] = useState([])

  // Guardar configuración de columnas
  const saveColumnSettings = () => {
    try {
      if (tableRef.current) {
        const currentColumns = tableRef.current.state?.columns
        if (currentColumns) {
          // Guardar solo los campos necesarios
          const columnsConfig = currentColumns.map(col => ({
            field: col.field,
            hidden: col.hidden
          }))
          localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(columnsConfig))
        }
      }
    } catch (error) {
      console.error('Error al guardar configuración de columnas:', error)
    }
  }

  // Manejar cambios en la visibilidad de columnas
  const handleColumnHiddenChange = () => {
    setTimeout(saveColumnSettings, 100)
  }

  // Manejar arrastre de columnas
  const handleColumnDragged = () => {
    setTimeout(saveColumnSettings, 100)
  }

  // Cargar y aplicar configuración de columnas
  useEffect(() => {
    const baseColumns = getBaseColumns()
    
    try {
      const savedColumnsConfig = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (savedColumnsConfig) {
        const savedColumns = JSON.parse(savedColumnsConfig)
        
        // Aplicar configuración guardada a las columnas base
        const updatedColumns = baseColumns.map(col => {
          const savedCol = savedColumns.find(c => c.field === col.field)
          if (savedCol) {
            return { ...col, hidden: savedCol.hidden }
          }
          return col
        })
        
        setColumns(updatedColumns)
      } else {
        setColumns(baseColumns)
      }
    } catch (error) {
      console.error('Error al cargar configuración de columnas:', error)
      setColumns(baseColumns)
    }
  }, [materials]) // Actualizar cuando cambian los materiales para reflejar los nuevos valores

  useEffect(() => 
    // Guardar configuración cuando se desmonte el componente
     () => {
      saveColumnSettings()
    }
  , [])

  useEffect(() => {
    console.log(loading, '123')
  }, [])
  return (
    <Card className={classes.container}>
      <Alert
        title={alertInfo.title}
        content={alertInfo.content}
        textBtn1={alertInfo.textBtn1}
        textBtn2={alertInfo.textBtn2}
        funcBtn={alertInfo.funcBtn}
        open={alertInfo.open}
        onClose={onCloseAlert}
      />
      <Typography className={classes.title}>{title}</Typography>
      <MaterialTable
        tableRef={tableRef}
        title=""
        isLoading={loading}
        data={materials}
        columns={columns}
        onColumnDragged={handleColumnDragged}
        onChangeColumnHidden={handleColumnHiddenChange}
        options={{
          pageSize: 20,
          columnsButton: true,
          pageSizeOptions: [20, 50, 100],
          headerStyle: {
            backgroundColor: '#4c75aa',
            color: '#f1f1f1',
            fontSize: '14px',
            fontWeight: 700,
            position: 'sticky', 
            zIndex: '10'
          },
          maxBodyHeight: '500px',
          rowStyle: (rowData, index) => ({
            backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
            padding: '5px',
            fontSize: '12px',
          }),
        }}
      />
    </Card>
  )
}

export { MaterialsTableShared }
